import { ChangeDetectionStrategy, Component, input } from '@angular/core';

export type UiSponsorBadgeVariant = 'blue' | 'orange' | 'green';
// 'compact' cubre el layout angosto de la tarjeta de crédito (icon-pay-tc): texto en una línea,
// ancho máximo fijo e ícono empujado al extremo derecho.
export type UiSponsorBadgeLayout = 'default' | 'compact';

@Component({
  selector: 'app-ui-sponsor-badge',
  template: `
    <div
      class="ui-sponsor-badge"
      [class.ui-sponsor-badge--blue]="variant() === 'blue'"
      [class.ui-sponsor-badge--orange]="variant() === 'orange'"
      [class.ui-sponsor-badge--green]="variant() === 'green'"
      [class.ui-sponsor-badge--compact]="layout() === 'compact'"
    >
     <img [src]="icon()" [title]="label()" [alt]="label()" />
      <p>{{ label() }}</p>
    </div>
  `,
  styleUrl: './ui-sponsor-badge.component.scss',
  changeDetection: ChangeDetectionStrategy.OnPush,
})
export class UiSponsorBadgeAtomComponent {
  readonly label = input.required<string>();
  readonly icon = input.required<string>();
  readonly variant = input<UiSponsorBadgeVariant>('blue');
  readonly layout = input<UiSponsorBadgeLayout>('default');
}
